import React, { useEffect, useState } from 'react';
import PageLoader from '../components/ui/PageLoader';
import { getCommunicationBootstrap } from '../services/communicationService';
import '../assets/styles/PaymentReminders.scss';

const channels = (policy) => {
  try { return Array.isArray(policy.channels_json) ? policy.channels_json : JSON.parse(policy.channels_json || '[]'); }
  catch { return []; }
};

export default function PaymentReminderSettings() {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    getCommunicationBootstrap().then(setConfig).catch((cause) => setError(cause?.response?.data?.error || 'Could not load notification settings.'));
  }, []);

  const policies = (config?.paymentReminderPolicies || []).filter((policy) => Number(policy.is_enabled) === 1);
  const routes = (config?.rules || []).filter((route) => route.trigger_key === 'PAYMENT_REMINDER' && Number(route.is_enabled) === 1);
  return (
    <div className="leads-table-container payment-reminder-page">
      <div className="table-container payment-reminder-card" style={{ padding: 24 }}>
        <h2>Payment Reminder Settings</h2>
        <p>Automatic reminders follow the active schedule below. Delivery uses the enabled Notification routes, providers and templates.</p>
        <p>Invoices need a due date for automatic reminders. Invoices without one can be reminded manually.</p>
        <a href="/settings?section=communications&tab=reminders">Edit reminder policies and notification routes</a>
        {error ? <p role="alert">{error}</p> : null}
        {!config && !error ? <PageLoader message="Loading payment reminder settings..." minHeight={140} size={26} /> : null}
        {config ? <>
          <h3>Active schedules</h3>
          {policies.length ? policies.map((policy) => <div key={policy.id} className="auto-toggle-card">
            <div><strong>{policy.name}</strong><p>Channels: {channels(policy).join(', ') || 'None'} ? Send time: {policy.metadata?.send_time || '10:00'}</p><p>Before due: {(policy.before_due_days || []).join(', ') || 'None'} days ? Due date: {policy.send_on_due_date ? 'Yes' : 'No'} ? Overdue every {policy.overdue_every_days} days</p></div>
          </div>) : <p>No active reminder policy.</p>}
          <h3>Active notification routes</h3>
          {routes.length ? routes.map((route) => <div key={route.id} className="auto-toggle-card"><div><strong>{route.name}</strong><p>{route.channel} ? Provider: {(config.providers || []).find((provider) => Number(provider.id) === Number(route.provider_profile_id))?.name || 'Auto resolve'} ? Template: {(config.templates || []).find((template) => Number(template.id) === Number(route.template_id))?.name || 'Auto resolve'}</p></div></div>) : <p>No active payment reminder route.</p>}
        </> : null}
      </div>
    </div>
  );
}
